<template>
  <div style="width: 20px; margin: auto; position: relative; top: -10px">
    <v-checkbox
      v-model="checkbox"
      @change="updatePaidToGC()"
      hide-details
    ></v-checkbox>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      checkbox: false,
    }),
    watch: {
      params: function () {
        this.checkbox = parseInt(this.params.data.paidToGC);
      },
    },
    beforeCreate() {},
    mounted() {
      this.checkbox = parseInt(this.params.data.paidToGC);
    },
    methods: {
      updatePaidToGC() {
        let payload = this.params.data;
        payload.paidToGC = this.checkbox;
        this.$store.dispatch("business/salesEnquirySaveNoReload", payload);
      },
    },
  };
</script>

